<template>
  <div class="paper_list" v-if="list && list.length > 0">
    <div v-for="(item, index) in list" :key="index" class="practice_item_wrapper">
      <div class="practice_item">
        <img class="left_icon" v-if="tabs === 8" src="@/assets/paper/practice_everyday.svg" alt="" />
        <img class="left_icon" v-if="tabs === 7" src="@/assets/paper/practice_chapter.svg" alt="" />
        <img class="left_icon" v-if="tabs === 9" src="@/assets/paper/practice_emigrated.svg" alt="" />
        <img class="left_icon" v-if="tabs === 10" src="@/assets/paper/mock_exam.svg" alt="" />
        <div>
          <p class="name mgb10 font16">{{ item.courseName }}</p>
          <!-- <p class="c_999 mgb10">
          <span class="mgr20" v-if="tabs < 4 && item.practiceName">共{{item.questionCount}}题</span>
          <span class="mgr20" v-else-if="tabs === 4 && item.practiceName">共{{item.totalScore}}分</span>
          <span v-if="item.practiceName">共{{item.peopleNum}}人做过</span>
        </p> -->
          <p v-if="purchaseSwitch">
            <template v-if="isVipModal">
              <span class="current_price font20" v-if="item.vipPrice">
                <span class="font12">¥</span>{{ item.vipPrice }}
              </span>
              <span class="free font20" v-else>免费</span>
            </template>
            <template v-else>
              <span class="current_price font20" v-if="item.price > 0">
                <span class="font12">¥</span>{{ item.price }}
              </span>
              <span class="current_price font20" v-else>
                <span class="font12">&nbsp</span>
              </span>
            </template>
            <span class="line_price font12 c_999" v-if="item.price < item.linePrice">¥{{ item.linePrice }}</span>
          </p>
        </div>
        <el-button v-if="item.price > 0 && !item.buyStatus && purchaseSwitch" class="handle_btn" type="primary" size="default"
          @click="handleView(item)">前往获取</el-button>
        <div v-else class="handle_view" @click="handleView(item)">前往查看</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { setStore,getSession } from "../../utils/storage";
import { onMounted, reactive, computed } from "vue";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/stores/user";
import cookie from "@/utils/cookies";

const route = useRoute();
const router = useRouter();
const store = useUserStore();
const { getEnumList,shopData } = useUserStore();
const token = computed(() => store.token);
const props = defineProps({
  list: {
    type: Array,
    default: [],
  },
  tabs: {
    type: [String, Number],
    default: "",
  },
  // 会员模块展示商品数据显示会员价格
  isVipModal: {
    type: Boolean,
    default: false,
  },
});
const opts = reactive({
  userPracticeStatusEnum: {},
});

// 价格开关
const purchaseSwitch = computed(() => {
  try {
    const shopDataCache = getSession('shopInfo') ? JSON.parse(getSession('shopInfo')) : null;
    const shopId = shopDataCache?.id ?? shopData?.value?.id ?? (process.client ? cookie.getInClient('shopId') : null);
    
    return shopDataCache?.config?.purchaseSwitch ?? shopData?.value?.config?.purchaseSwitch ?? false;
  } catch (e) {
    const shopId = shopData?.value?.id ?? (process.client ? cookie.getInClient('shopId') : null);
    
    return shopData?.value?.config?.purchaseSwitch ?? false;
  }
});


const handleView = (row) => {
  let url = "/paper/childrenList";
  router.push({
    path: url,
    query: {
      id: row.id || row.goodsId,
    },
  });
};
onMounted(() => {
  getEnumList("UserPracticeStatusEnum", "obj").then((res) => {
    opts.userPracticeStatusEnum = res;
  });
});
</script>

<style scoped lang="scss">
.paper_list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}

.practice_item_wrapper {
  margin-bottom: 20px;
  padding: 0 10px;
  width: 50%;
}

.practice_item_wrapper:nth-last-child(-n + 2) {
  margin-bottom: 0;
}

.practice_item {
  position: relative;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  column-gap: 12px;
  background: #ffffff;
  border: 1px solid #ebeef5;

  &:hover {
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
    transition: all 0.3s;
  }

  .name {
    width: 430px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .current_price {
    color: #f61818;
  }

  .free {
    color: #58b85c;
  }

  .line_price {
    text-decoration: line-through;
    margin-left: 5px;
  }

  .handle_btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  .handle_view {
    position: absolute;
    right: 20px;
    bottom: 20px;
    background: rgba(61, 127, 255, .1);
    color: #3d7fff;
    padding: 6px 17px;
    border-radius: 5px;
  }
}
</style>
